export function withoutDeletedTwin(document, nodeId, twinId) {
  if (document.twinIds?.[nodeId] && document.twinIds[nodeId] !== twinId) throw new Error("TWIN_DELETE_BINDING_CHANGED");
  const twinIds = { ...document.twinIds }, configs = { ...document.configs };
  delete twinIds[nodeId];
  delete configs[nodeId];
  return { ...document, twinIds, configs };
}
